import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { graphql } from "gatsby"
import nl2br from "../../utils/nl2br"
import RetinaImageWrapper from "../../components/RetinaImage"

import "./styles.less"

export default ({ data }) => {
  const pageData = data.cms.pageData
  const globals = data.cms.globals

  return (
    <Layout mainClassName={"sp-list"}>
      <SEO
        title={pageData.metaTitle}
        description={pageData.metaDescription}
        image={
          pageData.metaImage[0]
            ? pageData.metaImage[0].url
            : globals.metaImage[0].url
        }
        jsonSchema={pageData.jsonSchema}
      />

      <div className="container mb-5 pb-5">
        <div className="row">
          <div className="col-xl-8">
            <h1>{nl2br(pageData.pageTitle)}</h1>
          </div>
        </div>

        <div className="row custom-row">
          {pageData.partners.map((partner, idx) => (
            <SP key={idx} partner={partner} />
          ))}
        </div>
      </div>
    </Layout>
  )
}

const SP = ({ partner }) => {
  return (
    <div className="col-6 col-md-4 col-lg-3">
      <SpLinkBlock partner={partner}>
        <div className="img">
          <RetinaImageWrapper
            image={partner.spImage[0]}
            retinaImage={partner.spImageRetina[0]}
          />
        </div>
        <h5>{partner.spTitle}</h5>
        <p>{partner.spText}</p>
      </SpLinkBlock>
    </div>
  )
}

const SpLinkBlock = ({ partner, children }) => {
  if (partner.spLink) {
    return (
      <a
        href={partner.spLink}
        className="sp-block"
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        {children}
      </a>
    )
  }
  return <div className="sp-block">{children}</div>
}

export const query = graphql`
  query {
    cms {
      globals: globalSet {
        id
        ... on Cms_metadata_GlobalSet {
          id
          metaImage {
            url(width: 1200)
          }
        }
      }
      pageData: entry(section: "servicePartners") {
        id
        ... on Cms_servicePartners_servicePartners_Entry {
          id
          pageTitle
          metaTitle
          metaDescription
          jsonSchema
          metaImage {
            url(width: 1200, height: 630)
          }
          partners {
            ... on Cms_partners_partner_BlockType {
              id
              spTitle
              spText
              spImage {
                url(width: 300, height: 300, mode: "fit")
                title
              }
              spImageRetina: spImage {
                url(width: 600, height: 600, mode: "fit")
                title
              }
              spLink
            }
          }
        }
      }
    }
  }
`
